import { render, staticRenderFns } from "./OwnPendingSignatures.vue?vue&type=template&id=2dae8e90&"
import script from "./OwnPendingSignatures.vue?vue&type=script&lang=ts&"
export * from "./OwnPendingSignatures.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports